var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 15914"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 28.5,
    cy: 28,
    r: 25,
    fill: "#6C6C6C",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 18",
    d: "M38 27L38 26.05C38 23.8132 36.433 22 34.5 22C32.567 22 31 23.8132 31 26.05L31 27",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 20",
    d: "M26.5 27L26.5 26.05C26.5 23.8132 24.933 22 23 22C21.067 22 19.5 23.8132 19.5 26.05L19.5 27",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 34",
    d: "M13.5 19.5L20 14",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 39",
    d: "M44 19.5L37.5 14",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 19",
    d: "M29 39C27.7194 39 26.5874 38.4572 25.7695 37.6592C24.939 36.8487 24.5 35.8444 24.5 35L24.5 33.04L33.5 33.04L33.5 35C33.5 35.8444 33.061 36.8487 32.2305 37.6592C31.4126 38.4572 30.2806 39 29 39Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHope);
export default __webpack_public_path__ + "static/media/Hope.dcdca87b43f06744dec8394002f8ba0d.svg";
export { ForwardRef as ReactComponent };